import * as R from "ramda";

const messages = {
  like: "liked your case",
  comment: "commented on your case",
  commentOn: "commented on a case you commeted on",
  follow: "followed you",
  publish: "published a case",
};

export const formatNotification = notification => {
  const postInteractions = ["like", "comment", "commentOn"];
  const followInteractions = ["follow", "publish"];

  if (R.contains(notification.interactionType, postInteractions)) {
    return formatPostInteraction(notification);
  } else if (R.contains(notification.interactionType, followInteractions)) {
    return formatFollowInteraction(notification);
  }
};

export const formatNotificationMessage = ({ type, name, count }) =>
  `${name} ${count > 1 ? ` and ${count - 1} more people ` : " "}` + messages[type];

const formatPostInteraction = notification => {
  const {
    data,
    targetId: postId,
    interactionType: type,
    lastUpdatedAt,
    isSeen,
    postTitle,
    lastActor: { id: actorId, name, picture },
  } = notification;

  return {
    actor: { path: `/profile/${actorId}`, picture, actorId },
    path: `/posts/${postId}`,
    lastUpdatedAt,
    isSeen,
    postTitle,
    message: formatNotificationMessage({ type, name, count: Object.keys(data).length }),
  };
};

const formatFollowInteraction = notification => {
  const {
    interactionType: type,
    targetId,
    lastUpdatedAt,
    isSeen,
    postTitle,
    actor: { id: actorId, name, picture },
  } = notification;

  const notificationData = {
    actor: { path: `/profile/${actorId}`, picture, actorId },
    lastUpdatedAt,
    isSeen,
    postTitle,
    message: formatNotificationMessage({ type, name }),
  };

  switch (type) {
    case "follow":
      notificationData.path = `/profile/${targetId}`;
      break;

    case "publish":
      notificationData.path = `/posts/${targetId}`;
      break;

    default:
      notificationData.path = `/profile/${actorId}`;
  }

  return notificationData;
};



// WEBPACK FOOTER //
// ./src/util/notificationMessages.js